import http from "@/services/http";
import { useAuth } from "@/services/auth.js";

export const stats = () => {
  const auth = useAuth();

  async function overview() {
    try {
      const { data } = await http.get('/admin/stats/overview', auth.getBearer());
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return null;
    }
  }

  async function serverStats() {
    try {
      const { data } = await http.get('/admin/server-stats', auth.getBearer());
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return null;
    }
  }

  return { overview, serverStats }
}
